import { CALL_API } from 'middlewares/api';
import { defaultHeaders } from 'services/apiService';
import settings from 'front-settings';

// Get cms content
export const PAGE_REQUEST = 'cmsContent/PAGE_REQUEST';
export const PAGE_SUCCESS = 'cmsContent/PAGE_SUCCESS';
export const PAGE_FAILURE = 'cmsContent/PAGE_FAILURE';

// Get all cms pages meta
export const PAGES_REQUEST = 'cmsContent/PAGES_REQUEST';
export const PAGES_SUCCESS = 'cmsContent/PAGES_SUCCESS';
export const PAGES_FAILURE = 'cmsContent/PAGES_FAILURE';

const initialState = {
  pages: {},
  slugs: undefined,
};

/**
 * REDUCER
 * --------------------------------------------------------- *
 */
const cmsContent = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_SUCCESS:
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.data.id]: action.data,
        },
      };

    case PAGES_SUCCESS:
      return {
        ...state,
        slugs: action.data.items.reduce((acc, curr) => ({
          [curr.meta.slug || `noslug_${curr.id}`]: curr,
          ...acc,
        }), {}),
      };

    default:
      return state;
  }
};

export default cmsContent;


/**
 * ACTIONS
 * --------------------------------------------------------- *
 */

/**
 * cmsContent action
 * getPage fetch page from wagtail with given id
 * @param {string} id - requested page id
 */
export const getPage = id => ({
  [CALL_API]: {
    endpoint: `${settings.CMS_URL}/api/v2/pages/${id}/`,
    types: [PAGE_REQUEST, PAGE_SUCCESS, PAGE_FAILURE],
    config: { headers: defaultHeaders },
  },
});

/**
 * cmsContent action
 * getPages fetch all pages metadata from wagtail
 */
export const getPages = () => ({
  [CALL_API]: {
    endpoint: `${settings.CMS_URL}/api/v2/pages/`,
    types: [PAGES_REQUEST, PAGES_SUCCESS, PAGES_FAILURE],
    config: { headers: defaultHeaders },
  },
});



// WEBPACK FOOTER //
// ./src/modules/CMS/reducers/index.js